import ExceptionCodes from '../exception_codes';
import otErrorFactory from '../../helpers/otError';
import Errors from '../Errors';

const otError = otErrorFactory();

export default (err) => {
  if (String(err.code) === '404') {
    return otError(
      Errors.STREAM_NOT_FOUND,
      new Error('stream not found'),
      ExceptionCodes.UNABLE_TO_SUBSCRIBE
    );
  }

  if (String(err.code) === '409' && err.message === 'streamLimitExceeded') {
    return otError(
      Errors.STREAM_LIMIT_EXCEEDED,
      new Error('The limit for concurrent streams in the session has been reached'),
      ExceptionCodes.STREAM_LIMIT_EXCEEDED
    );
  }

  if (String(err.code) === '405' && err.message === 'IncompatibleEncryptionSettings') {
    return otError(
      Errors.UNABLE_TO_SUBSCRIBE,
      new Error('Tried to subscribe to an encrypted stream without enabling encryption'),
      ExceptionCodes.UNABLE_TO_SUBSCRIBE
    );
  }

  if (String(err.code) === '500' && err.message === 'Not connected.') {
    return otError(
      Errors.UNABLE_TO_SUBSCRIBE,
      new Error('Tried to subscribe to a stream while disconnected.'),
      ExceptionCodes.UNABLE_TO_SUBSCRIBE
    );
  }

  return otError(
    Errors.UNABLE_TO_SUBSCRIBE,
    new Error(`subscriberCreate failed with unexpected code ${err.code}: ${err.message}`),
    ExceptionCodes.UNEXPECTED_SERVER_RESPONSE
  );
};
